import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../components/Navigation';
import { Shield, Lock, Eye, Trash2, Mail, FileText } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();

  const sectionIcons = [
    <FileText className="w-6 h-6" style={{ color: '#A8922A' }} />,
    <Lock className="w-6 h-6" style={{ color: '#A8922A' }} />,
    <Eye className="w-6 h-6" style={{ color: '#A8922A' }} />,
    <Shield className="w-6 h-6" style={{ color: '#A8922A' }} />,
    <Trash2 className="w-6 h-6" style={{ color: '#A8922A' }} />,
    <Mail className="w-6 h-6" style={{ color: '#A8922A' }} />,
  ];

  const sectionKeys = [
    'dataCollection',
    'dataUse',
    'dataStorage',
    'gdpr',
    'userRights',
    'contactPrivacy',
  ];

  const sectionsData = [
    {
      content: [
        'ValueBook platforma prikuplja samo one lične podatke koji su neophodni za funkcionisanje platforme i pružanje usluga korisnicima.',
        'Podaci koji se prikupljaju uključuju: ime i prezime, adresu elektronske pošte, broj telefona (opciono) i podatke o transakcijama unutar platforme.',
        'Podaci se prikupljaju isključivo uz izričitu saglasnost korisnika prilikom registracije ili korišćenja platforme.'
      ]
    },
    {
      content: [
        'Lični podaci korisnika koriste se isključivo u svrhe funkcionisanja ValueBook platforme.',
        'Vaši podaci se NE dele sa trećim stranama, partnerima, oglašivačima niti bilo kojim drugim subjektima izvan platforme.',
        'Podaci se koriste za: autentifikaciju korisnika, upravljanje novčanikom i vaučerima, komunikaciju između korisnika platforme i slanje sistemskih obaveštenja.'
      ]
    },
    {
      content: [
        'Lični podaci se čuvaju na sigurnim serverima uz primenu savremenih bezbednosnih mera zaštite.',
        'Podaci se čuvaju onoliko dugo koliko je korisnik aktivan na platformi, ili dok korisnik ne zatraži brisanje svog naloga.',
        'Nakon brisanja naloga, svi lični podaci se trajno uklanjaju iz sistema u roku od 30 dana, osim podataka koje je zakonski obavezno čuvati.'
      ]
    },
    {
      content: [
        'ValueBook platforma posluje u skladu sa Opštom uredbom o zaštiti podataka (GDPR) Evropske unije i relevantnim lokalnim propisima o zaštiti podataka.',
        'Korisnici imaju pravo na pristup, ispravku, prenosivost i brisanje svojih ličnih podataka u bilo kom trenutku.',
        'Obrada podataka se vrši na osnovu legitimnog interesa i izričite saglasnosti korisnika, u skladu sa principima zakonitosti, poštenja i transparentnosti.'
      ]
    },
    {
      content: [
        'Svaki korisnik ima pravo da u bilo kom trenutku zatraži uvid u svoje lične podatke koji se obrađuju na platformi.',
        'Korisnici mogu zatražiti ispravku netačnih podataka, ograničenje obrade ili potpuno brisanje svih ličnih podataka.',
        'Zahtev za brisanje podataka možete podneti putem elektronske pošte na adresu admin@valuebook.rs. Zahtev će biti obrađen u roku od 30 dana.'
      ]
    },
    {
      content: [
        'Za sva pitanja, zahteve ili prigovore u vezi sa obradom ličnih podataka, možete nas kontaktirati putem elektronske pošte.',
        'Odgovorni za zaštitu podataka: admin@valuebook.rs',
        'Trudimo se da odgovorimo na sve upite u roku od 5 radnih dana.'
      ]
    },
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#FAFAFA' }}>
      <Navigation />
      <section className="text-white py-16" style={{ background: 'linear-gradient(135deg, #23395B 0%, #3A5A8A 100%)' }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center">
              <Shield className="w-8 h-8 text-white" />
            </div>
          </div>
          <h1 className="text-4xl font-bold mb-4">{t('privacy.title')}</h1>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: '#D6E0EE' }}>{t('privacy.subtitle')}</p>
          <p className="text-sm mt-4" style={{ color: '#94a3b8' }}>{t('privacy.lastUpdated')}</p>
        </div>
      </section>
      <section className="py-10 bg-white border-b">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="flex items-start gap-3 p-4 rounded-xl" style={{ backgroundColor: '#F5EBB9' }}>
              <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#F5EBB9', border: '1px solid #CFB53B' }}>
                <Lock className="w-5 h-5" style={{ color: '#A8922A' }} />
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-sm">{t('privacy.noSharing')}</h3>
                <p className="text-gray-600 text-xs mt-1">{t('privacy.noSharingDesc')}</p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-4 rounded-xl" style={{ backgroundColor: '#F5EBB9' }}>
              <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#F5EBB9', border: '1px solid #CFB53B' }}>
                <Shield className="w-5 h-5" style={{ color: '#A8922A' }} />
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-sm">{t('privacy.gdpr')}</h3>
                <p className="text-gray-600 text-xs mt-1">{t('privacy.gdprDesc')}</p>
              </div>
            </div>
            <div className="flex items-start gap-3 p-4 rounded-xl" style={{ backgroundColor: '#F5EBB9' }}>
              <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#F5EBB9', border: '1px solid #CFB53B' }}>
                <Trash2 className="w-5 h-5" style={{ color: '#A8922A' }} />
              </div>
              <div>
                <h3 className="font-bold text-gray-900 text-sm">{t('privacy.deleteRight')}</h3>
                <p className="text-gray-600 text-xs mt-1">{t('privacy.deleteRightDesc')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-8">
            {sectionKeys?.map((key, idx) => (
              <div key={key} id={`section-${idx + 1}`} className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#F5EBB9' }}>
                    {sectionIcons?.[idx]}
                  </div>
                  <h2 className="text-xl font-bold text-gray-900">
                    <span className="mr-2" style={{ color: '#A8922A' }}>{idx + 1}.</span>
                    {t(`privacy.sections.${key}`)}
                  </h2>
                </div>
                <ul className="space-y-3">
                  {sectionsData?.[idx]?.content?.map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span className="w-2 h-2 rounded-full mt-2 flex-shrink-0" style={{ backgroundColor: '#A8922A' }}></span>
                      <p className="text-gray-700 leading-relaxed">{item}</p>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 text-white rounded-2xl p-8 text-center" style={{ background: 'linear-gradient(135deg, #A8922A 0%, #CFB53B 100%)' }}>
            <Mail className="w-10 h-10 mx-auto mb-4 text-white" />
            <h3 className="text-xl font-bold mb-2">{t('privacy.privacyQuestion')}</h3>
            <p className="mb-4" style={{ color: 'rgba(255,255,255,0.9)' }}>{t('privacy.privacyQuestionDesc')}</p>
            <a
              href="mailto:admin@valuebook.rs"
              className="inline-block bg-white font-bold px-6 py-3 rounded-lg hover:bg-yellow-50 transition-colors"
              style={{ color: '#A8922A' }}
            >
              admin@valuebook.rs
            </a>
          </div>

          <div className="mt-8 text-center">
            <Link to="/" className="font-medium transition-colors" style={{ color: '#A8922A' }}>
              {t('privacy.backLink')}
            </Link>
          </div>
        </div>
      </section>
      <footer className="text-white py-8 mt-8" style={{ backgroundColor: '#23395B' }}>
        <div className="max-w-4xl mx-auto px-4 text-center">
          <p className="text-sm" style={{ color: '#94a3b8' }}>{t('privacy.copyright')}</p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicyPage;
